import React from 'react'
import {
  ListBase,
  useListContext,
  Pagination,
  FilterForm,
  ReferenceField,
  ChipField
} from 'react-admin'
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  Chip,
  Box,
  Stack
} from '@mui/material'
import {
  FingerprintOutlined,
  Verified,
  Block,
  ErrorOutline,
  CalendarMonth,
  ThumbUpAlt,
  ThumbDownAlt,
  MoreHoriz,
  Domain
} from '@mui/icons-material'

import StyledBadge from 'components/styled/Badge'
import LocaleDateField from 'components/LocaleDateField'
import CardValidationTabs from 'resources/card_validation/CardValidationTab'
import { ButtonContainer, StyledFilterButton } from 'styles'
import CardValidationFilters from 'resources/card_validation/CardValidationFilters'

const resultIcon = (result) => {
  switch (result) {
    case 'authorized':
      return <Verified />
    case 'unauthorized':
      return <Block />
    default:
      return <ErrorOutline />
  }
}

const statusIcon = (status) => {
  switch (status) {
    case 'OK':
      return <ThumbUpAlt />
    case 'NOK':
      return <ThumbDownAlt />
    default:
      return <MoreHoriz />
  }
}

const statusColor = (status) => {
  switch (status) {
    case 'OK':
      return 'success'
    case 'NOK':
      return 'error'
    default:
      return 'info'
  }
}

const CardValidationView = () => {
  const { data } = useListContext()
  if (!data) return null
  return (
    <Grid spacing={2} container>
      {
        data.map((record) => {
          const status = record.context?.card_validation?.status
          return (
            <Grid item key={record.id} sm={12} md={6} lg={12}>
              <Card
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                <CardHeader
                 title={
                  <Stack spacing={1} direction="row" sx={{ paddingBottom: 1 }}>
                    <StyledBadge badgeContent="id" color='error' sx={{ fontSize: '32px' }}>
                      <FingerprintOutlined sx={{ fontSize: 35 }} />
                    </StyledBadge>
                    <Chip label={record.id} style={{ marginLeft: 4, fontSize: 20 }}/>
                  </Stack>
                 }
                 subheader={
                  <Stack spacing={1} direction="row">
                     <Chip icon={resultIcon(record.result)} label={record.result} color="primary" style={{ marginLeft: 4 }}/>
                     <Chip icon={statusIcon(status)} label={status || 'Not available'} color={statusColor(status)} style={{ marginLeft: 4 }}/>
                     <Box display="flex" alignItems="center" gap={1}>
                          <CalendarMonth/>
                          <LocaleDateField source="created_at" locales="pt-BR" showTime record={record} />
                      </Box>
                      <ReferenceField source="context.domain_id" reference="domains" record={record}>
                          <ChipField source='alias' icon={<Domain />}></ChipField>
                      </ReferenceField>
                  </Stack>
                 }
                />
                <CardContent sx={{ flexGrow: 1 }} >
                  <CardValidationTabs record={record} />
                </CardContent>
              </Card>
            </Grid>
          )
        })
      }
    </Grid>
  )
}

const CardValidationList = () => {
  return (
  <ListBase>
    <ButtonContainer>
      <FilterForm filters={CardValidationFilters} />
      <StyledFilterButton filters={CardValidationFilters} />
    </ButtonContainer>
    <CardValidationView />
    <Pagination rowsPerPageOptions={[10, 15, 20]} />
  </ListBase>
  )
}

export default CardValidationList
